import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore, User } from "oidc-client-ts";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const oidcConfig = {
  authority: process.env.REACT_APP_IDP as string,
  client_id: process.env.REACT_APP_CLIENT_ID as string,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI as string,
  client_secret: process.env.REACT_APP_CLIENT_SECRET,
  extraQueryParams:{
    user_type:"board_member"
  },
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: false,
  // Firefox-specific settings
  loadUserInfo: true,
  monitorSession: false,
  // Prevent automatic silent renew which can cause issues in Firefox
  includeIdTokenInSilentRenew: false,
};

const onSigninCallback = (user: User | void): void => {
  const returnTo =
    user && typeof (user.state as { returnTo?: unknown })?.returnTo === "string"
      ? (user.state as { returnTo: string }).returnTo
      : null;

  // Clean up OAuth parameters from URL after successful sign-in
  const url = new URL(window.location.href);
  
  // Remove OAuth query parameters
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  url.searchParams.delete('session_state');
  url.searchParams.delete('iss');
  
  const cleanUrl = url.pathname + (url.search || '') + (url.hash || '');

  // Navigate to the intended route when it differs from where the callback landed.
  if (returnTo && returnTo !== cleanUrl) {
    window.location.replace(returnTo);
    return;
  }
  
  window.history.replaceState(
    {},
    document.title,
    cleanUrl
  );
}

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
